"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CurrentPageContext = require("./CurrentPageContext");

Object.keys(_CurrentPageContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CurrentPageContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CurrentPageContext[key];
    }
  });
});

var _page404WithoutContext = require("./page404WithoutContext");

Object.keys(_page404WithoutContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _page404WithoutContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _page404WithoutContext[key];
    }
  });
});

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});